import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import { AlarmDetails, SeverityTypesEnum } from "../types";
import ConfirmationDialog from "./ConfirmationDialog";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
import { alarmsApi } from "../../../services/api";
import SelectInputSeverity, { Option } from "./AlarmSelectSeverity";
export type NewSeverity = yup.InferType<typeof schema>;
const schema = yup.object().shape({
  severity: yup.number().required("Severidade do alarme é obrigatório"),
});

const initialEditingState = {
  severity: false,
};
export function AlarmSelectModal(props: {
  showAddFormModal: boolean;
  setShowAddFormModal: (value: boolean) => void;
  onMount: () => void;
  alarm: AlarmDetails | null;
}) {
  const { showAddFormModal, setShowAddFormModal, onMount, alarm } = props;
  const [showAddItemConfirmationModal, setShowAddItemConfirmationModal] =
    useState<boolean>(false);
  const onClose = () => setShowAddFormModal(false);
  const [showAddItemSuccesModal, setShowAddItemSuccessModal] =
    useState<boolean>(false);
  const [showItemErrorModal, setShowItemErrorModal] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState(initialEditingState);
  const path = window.location.pathname;
  const alarmCode = path.split("/")[3];
  const [originalSeverity] = useState<SeverityTypesEnum | undefined>(undefined);
  const [, setSaveConfirmationOpen] = useState<boolean>(false);
  const [editSeverity, setEditSeverity] = useState(false);
  const [severity] = useState<SeverityTypesEnum | undefined>(
    alarm?.severity || undefined
  );
  const [isCancelConfirmationOpen, setCancelConfirmationOpen] =
    useState<boolean>(false);
  const [selectedSeverity, setSelectedSeverity] = useState<string>(
    severity ? severity.toString() : ""
  );

  const severityOptions: Option[] = [
    {
      value: SeverityTypesEnum.bland.toString(),
      label: "Brando",
    },
    {
      value: SeverityTypesEnum.medium.toString(),
      label: "Médio",
    },
    {
      value: SeverityTypesEnum.severe.toString(),
      label: "Severo",
    },
  ];

  const onSubmit = () => {
    setShowAddItemConfirmationModal(true);
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const checkIfIsSeverityEnum = (severity: number) => {
    if (!(typeof severity == "number")) {
      return false;
    }
    return Object.values(SeverityTypesEnum).includes(severity);
  };

  const handleConfirm = async (key: string) => {
    const severity = Number(selectedSeverity);

    if (!checkIfIsSeverityEnum(severity)) {
      return;
    }
    const updateSeverity = await alarmsApi.patchSeverity(alarmCode, severity);
    console.log("Alarme Alterado:", updateSeverity);
    setShowAddItemConfirmationModal(false);
    setIsEditing((prevEditingState) => ({
      ...prevEditingState,
      [key]: isEditing,
    }));
  };

  function getSeverityByType(type: SeverityTypesEnum): string {
    switch (type) {
      case SeverityTypesEnum.bland:
        return "Brando";
      case SeverityTypesEnum.medium:
        return "Médio";
      case SeverityTypesEnum.severe:
        return "Severo";
      default:
        return "";
    }
  }
  const handleSave = () => {
    setShowAddItemSuccessModal(true);
  };

  const handleCancelSeverityModal = () => {
    if (editSeverity) {
      // Reverte as alterações ao estado original
      setSelectedSeverity(originalSeverity?.toString() || "");
      setEditSeverity(false);
      setCancelConfirmationOpen(false);
    } else {
      setSaveConfirmationOpen(false);
    }
  };

  const handleSeverityChange = (newSeverity: string) => {
    setSelectedSeverity(newSeverity);
  };

  const handleCancel = () => {
    onClose();
    onMount();
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAddFormModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          {`Alterar a severidade do alarme `}
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          dividers
        >
          <Grid onSubmit={handleSubmit(onSubmit)} component={"form"}>
            <Grid item xs={12} sx={{ paddingY: "25px" }}>
              <SelectInputSeverity
                control={control}
                fieldName="severity"
                label={alarm?.severity ? getSeverityByType(alarm.severity) : ""}
                errors={errors}
                sx={{
                  marginBottom: "10px",
                }}
                options={severityOptions}
                onChange={handleSeverityChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <DialogActions sx={{ marginBottom: "-15px" }}>
              <Button color="secondary" onClick={handleCancel}>
                {"Cancelar"}
              </Button>
              <Button
                variant="contained"
                color={"primary"}
                type="submit"
                onClick={handleSave}
                disabled={selectedSeverity === alarm?.severity?.toString()}
              >
                {"Confirmar"}
              </Button>
            </DialogActions>
          </Grid>
        </DialogContent>
      </Dialog>
      <ConfirmationDialog
        open={isCancelConfirmationOpen}
        title="Descartar alteração"
        message="Deseja descartar e cancelar as alterações?"
        onConfirm={handleCancelSeverityModal}
        onCancel={() => setShowAddItemConfirmationModal(false)}
        onClose={() => setShowAddItemConfirmationModal(false)}
      />
      <ConfirmationModal
        setOpen={setShowAddItemConfirmationModal}
        setOpenErrorModal={setShowItemErrorModal}
        setOpenSuccessModal={setShowAddItemSuccessModal}
        open={showAddItemConfirmationModal}
        title="Editar severidade"
        contentText={`Deseja confirmar a edição da severidade do alarme?`}
        onConfirm={() => handleConfirm("severity")}
      />

      <ActionAlert
        message={`Alteração da severidade do alarme realizada com sucesso`}
        severity="success"
        open={showAddItemSuccesModal}
        setOpen={setShowAddItemSuccessModal}
        onClose={() => {
          setShowAddFormModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message={`Ocorreu um erro ao alterar a severidade do alarme`}
        severity="error"
        open={showItemErrorModal}
        setOpen={setShowItemErrorModal}
        onClose={() => {
          setShowItemErrorModal(false);
        }}
      />
    </>
  );
}
